module.exports = __webpack_public_path__ + "img/Pic_PDA_ICONs.a6732599.png";